import AuthSessionManagerService, { eventEmitter, getBrands } from '@mxp/gp-auth-lib';
import { VITE_CLIENT_ID, VITE_POST_LOGOUT_REDIRECT_URL,VITE_CLIENT_ID_CITI ,VITE_CITI_BRANDED_URL,VITE_BRAND_BASE_URL } from 'Constants/appEnvConstants';
import { getEnv } from 'Utils/featureFlagUtils';

let authServiceInstance = null;
let loginPromise = null;
const env = getEnv(window.location.hostname);

/**
 * Initializes AuthSessionManagerService instance for cross-tab communication.
 * CRITICAL for cross-tab logout: BroadcastChannelManager is created in the constructor,
 * so ALL tabs must create an instance, not just the tab that performed login.
 */
export const initAuthServiceForCrossTab = () => {
  if (!authServiceInstance) {
    getAuthService();
    }
  return authServiceInstance;
};


const setupBrandDetails = async () => {
  const existingBrandDetails = sessionStorage.getItem('brandDetails');
  if (existingBrandDetails && existingBrandDetails !== 'null') {
    try {
      const parsed = JSON.parse(existingBrandDetails);
      if (parsed && parsed.b2cClientId !== null && parsed.applicationId !== null) {
        return parsed;
      }
    } catch {
        console.warn('[gpAuthService] Failed to parse existing brand details, fetching from API instead');
    }
  }
  const visitedUrl = window.location.origin;
  const basePath = '/';

  try {
    const brandConfig = await getBrands(visitedUrl, basePath, { environment: env , baseUrl: VITE_BRAND_BASE_URL});    
    if (!brandConfig) throw new Error('Brand details could not be loaded.');
    sessionStorage.setItem('brandDetails', JSON.stringify(brandConfig));
    return brandConfig;
  } catch (error) {
    console.warn('[gpAuthService] Brand details request failed, continuing without brand details:', error);
    return null; 
  }
};

const getAuthService = () => {
  if (!authServiceInstance) {
    const { origin } = window.location;
    const authConfig = {
      clientId: origin.includes(VITE_CITI_BRANDED_URL) ? VITE_CLIENT_ID_CITI : VITE_CLIENT_ID,
      redirectUri: origin,
      postLogoutRedirectUri: VITE_POST_LOGOUT_REDIRECT_URL,
      environment: env,
      baseUrl: VITE_BRAND_BASE_URL
    };
    authServiceInstance = new AuthSessionManagerService(authConfig);
  }

  return authServiceInstance;
};

const gpAuthLogin = async (redirectPath, locale = 'en-US') => {
  if (loginPromise) return loginPromise;

  loginPromise = (async () => {
    try {
        const brandDetails = await setupBrandDetails();
        if (!brandDetails) {
            throw new Error('Brand details not available, aborting login.');
        }
        const authService = getAuthService();
        const result = await authService.login(redirectPath, locale);
        if (!result) {
          throw new Error('Login failed, no result returned.');
        }
        return result;
    } catch (error) {
      throw error;
    } finally {
      loginPromise = null;
    }
  })();

  return loginPromise;
};

export const getGpAuthLoginToken = async () => {
    try {
      const result = await gpAuthLogin('/', 'en-US');
    } catch (error) {
      console.error('[LayoutUnauthenticated] GP Auth login failed:', error);
    }
  };

  export const gpAuthLogout = async (VITE_POST_LOGOUT_REDIRECT_URI) => {
  if (!authServiceInstance) {
    getAuthService();
  }
  await authServiceInstance.logout(VITE_POST_LOGOUT_REDIRECT_URI);
};

export const resetInactivityTimer = async () => {
  // If auth service not initialized, user is not logged in yet - skip timer reset
  if (!authServiceInstance) {
    getAuthService();
  }
  authServiceInstance.resetTimer();
};

export { eventEmitter };
